import { MyleObjectType } from "@/Common/Models/Enum/MyleObjectType";
import { Guid } from "@/Common/Models/Guid";
import { SharedItem } from "@/Common/Models/Portal/SharedItem/SharedItem";
import { SharedItemMessage } from "@/Common/Models/Portal/SharedItem/SharedItemMessage";
import { IntegrationBusFactory } from "@/Common/Modularity/IntegrationBus/IntegrationBusFactory";

/** Payload for the EncounterLoadedEvent. */
type EncounterLoadedPayload = { encounterId: Guid; patientContactId: Guid };
/** Event triggered when an encounter is loaded. */
const EncounterLoadedEvent = IntegrationBusFactory.createEvent<EncounterLoadedPayload>("EncounterLoadedEvent");

/** Payload for the LoadingEncountersCacheEvent. */
type LoadingEncountersCachePayload = { encounterIds: Guid[] };
/** Event triggered when encounters are being loaded into the cache for the second screen. */
const LoadingEncountersCacheEvent = IntegrationBusFactory.createEvent<LoadingEncountersCachePayload>("LoadingEncountersCacheEvent");

/** Payload for the FinishPortalSyncEvent. */
type PortalSyncSuccessPayload = { portalSyncPopupType: MyleObjectType, encounterId: Guid; objectId: Guid; sharedItem: SharedItem; sharedItemMessages: SharedItemMessage[] };
/** Event triggered when the portal sync is finished succesfully. */
const PortalSyncSuccessEvent = IntegrationBusFactory.createEvent<PortalSyncSuccessPayload>("PortalSyncSuccessEvent");

/** Payload for the CleanEncountersCacheEvent. */
type CleanEncountersCachePayload = { patientContactId: Guid; remainingEncounterIds: Set<Guid> };
/** Event triggered to clean up encounters cache for the second screen. */
const CleanEncountersCacheEvent = IntegrationBusFactory.createEvent<CleanEncountersCachePayload>("CleanEncountersCacheEvent");

export {
    CleanEncountersCacheEvent,
    CleanEncountersCachePayload,
    EncounterLoadedEvent,
    EncounterLoadedPayload,
    LoadingEncountersCacheEvent,
    LoadingEncountersCachePayload,
    PortalSyncSuccessEvent,
    PortalSyncSuccessPayload
};
